var map = {
	"./adminuser-list/list.module": [
		"./src/app/features/adminuser/adminuser-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"adminuser-list-list-module"
	],
	"./bookswitcher-list/list.module": [
		"./src/app/features/bookswitcher/bookswitcher-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"bookswitcher-list-list-module"
	],
	"./change/change.module": [
		"./src/app/features/profile/change/change.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"change-change-module"
	],
	"./customerstatement-list/customerstatement-list.module": [
		"./src/app/features/report/customerstatement-list/customerstatement-list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"customerstatement-list-customerstatement-list-module"
	],
	"./features/adminuser/adminuser.module": [
		"./src/app/features/adminuser/adminuser.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-adminuser-adminuser-module"
	],
	"./features/auth/auth.module": [
		"./src/app/features/auth/auth.module.ts",
		"features-auth-auth-module"
	],
	"./features/auth/unauthorized/unauthorized.module": [
		"./src/app/features/auth/unauthorized/unauthorized.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"features-auth-unauthorized-unauthorized-module"
	],
	"./features/bookswitcher/bookswitcher.module": [
		"./src/app/features/bookswitcher/bookswitcher.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-bookswitcher-bookswitcher-module"
	],
	"./features/dashboard/dashboard.module": [
		"./src/app/features/dashboard/dashboard.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"features-dashboard-dashboard-module"
	],
	"./features/holiday/holiday.module": [
		"./src/app/features/holiday/holiday.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-holiday-holiday-module"
	],
	"./features/markup/markup.module": [
		"./src/app/features/markup/markup.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-markup-markup-module"
	],
	"./features/member/member.module": [
		"./src/app/features/member/member.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-member-member-module"
	],
	"./features/membergroup/membergroup.module": [
		"./src/app/features/membergroup/membergroup.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-membergroup-membergroup-module"
	],
	"./features/pricebuffer/pricebuffer.module": [
		"./src/app/features/pricebuffer/pricebuffer.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-pricebuffer-pricebuffer-module"
	],
	"./features/product/product.module": [
		"./src/app/features/product/product.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-product-product-module"
	],
	"./features/profile/profile.module": [
		"./src/app/features/profile/profile.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-profile-profile-module"
	],
	"./features/report/report.module": [
		"./src/app/features/report/report.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-report-report-module"
	],
	"./features/schedule/schedule.module": [
		"./src/app/features/schedule/schedule.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-schedule-schedule-module"
	],
	"./features/spread/spread.module": [
		"./src/app/features/spread/spread.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-spread-spread-module"
	],
	"./features/trade/trade.module": [
		"./src/app/features/trade/trade.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"common",
		"features-trade-trade-module"
	],
	"./features/tradeexecution/tradeexecution.module": [
		"./src/app/features/tradeexecution/tradeexecution.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"features-tradeexecution-tradeexecution-module"
	],
	"./features/traderesidue/traderesidue.module": [
		"./src/app/features/traderesidue/traderesidue.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"features-traderesidue-traderesidue-module"
	],
	"./forgot/forgot.module": [
		"./src/app/features/auth/forgot/forgot.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"forgot-forgot-module"
	],
	"./hedging-list/hedging-list.module": [
		"./src/app/features/report/hedging-list/hedging-list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"hedging-list-hedging-list-module"
	],
	"./holiday-list/list.module": [
		"./src/app/features/holiday/holiday-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"holiday-list-list-module"
	],
	"./locked/locked.module": [
		"./src/app/features/auth/locked/locked.module.ts",
		"locked-locked-module"
	],
	"./login/login.module": [
		"./src/app/features/auth/login/login.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"login-login-module"
	],
	"./markup-list/list.module": [
		"./src/app/features/markup/markup-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"markup-list-list-module"
	],
	"./member-list/list.module": [
		"./src/app/features/member/member-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"member-list-list-module"
	],
	"./memberbuyselllimit-list/memberbuyselllimit-list.module": [
		"./src/app/features/report/memberbuyselllimit-list/memberbuyselllimit-list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"memberbuyselllimit-list-memberbuyselllimit-list-module"
	],
	"./membergroup-list/list.module": [
		"./src/app/features/membergroup/membergroup-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"membergroup-list-list-module"
	],
	"./pricebuffer-list/list.module": [
		"./src/app/features/pricebuffer/pricebuffer-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"pricebuffer-list-list-module"
	],
	"./product-list/list.module": [
		"./src/app/features/product/product-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"product-list-list-module"
	],
	"./register/register.module": [
		"./src/app/features/auth/register/register.module.ts",
		"register-register-module"
	],
	"./schedule-list/list.module": [
		"./src/app/features/schedule/schedule-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"schedule-list-list-module"
	],
	"./spread-list/list.module": [
		"./src/app/features/spread/spread-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"spread-list-list-module"
	],
	"./trade-list/list.module": [
		"./src/app/features/trade/trade-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"common",
		"trade-list-list-module"
	],
	"./tradeexecution-list/list.module": [
		"./src/app/features/tradeexecution/tradeexecution-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"tradeexecution-list-list-module"
	],
	"./traderesidue-list/list.module": [
		"./src/app/features/traderesidue/traderesidue-list/list.module.ts",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~098be11c",
		"adminuser-list-list-module~bookswitcher-list-list-module~change-change-module~customerstatement-list~28471889",
		"bookswitcher-list-list-module~change-change-module~customerstatement-list-customerstatement-list-mod~409a461b",
		"common",
		"traderesidue-list-list-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;